import { isCmoeAllocationLedgerEnabled } from "../../config/cmoeFeatureFlags";
import { buildHoldDocId } from "../../domain/cmoe/allocation/allocationTypes";
import { canAcquireExclusiveHold, createHoldRecord, releaseHold } from "../../domain/cmoe/allocation/allocationLedger";
import { getRoomSessionPolicyBundle } from "../../domain/cmoe/policy/roomSessionPolicyBundle";
import { refreshActiveHoldsProjection } from "./projectionService";

/**
 * @param {import('../../repositories/cmoe/allocationRepository.interface').AllocationRepository} allocationRepo
 * @param {import('../../repositories/cmoe/projectionRepository.interface').ProjectionRepository} projectionRepo
 * @param {Object} params
 * @param {string} params.competitionId
 * @param {string} params.matchId
 * @param {'participant' | 'resource'} params.targetType
 * @param {string} params.targetId
 * @param {number} params.nowMs
 */
export async function acquireExclusiveHold(allocationRepo, projectionRepo, params) {
  if (!isCmoeAllocationLedgerEnabled()) {
    return { ok: false, code: "ALLOCATION_LEDGER_DISABLED" };
  }
  const policy = getRoomSessionPolicyBundle();
  const holdDocId = buildHoldDocId(params.competitionId, params.targetType, params.targetId);
  const existing = await allocationRepo.getHold(params.competitionId, holdDocId);
  const check = canAcquireExclusiveHold(
    existing,
    params.matchId,
    policy.allocation.allowConcurrentExclusiveParticipation
  );
  if (!check.ok) return check;
  const hold = createHoldRecord({
    competitionId: params.competitionId,
    matchId: params.matchId,
    targetType: params.targetType,
    targetId: params.targetId,
    nowMs: params.nowMs,
    epoch: (existing?.allocationEpoch || 0) + 1,
  });
  await allocationRepo.saveHold(params.competitionId, hold);
  await refreshActiveHoldsProjection(projectionRepo, allocationRepo, params.competitionId);
  return { ok: true, hold };
}

/**
 * @param {import('../../repositories/cmoe/allocationRepository.interface').AllocationRepository} allocationRepo
 * @param {import('../../repositories/cmoe/projectionRepository.interface').ProjectionRepository} projectionRepo
 * @param {string} competitionId
 * @param {string} matchId
 * @param {number} nowMs
 */
export async function releaseHoldsForMatch(allocationRepo, projectionRepo, competitionId, matchId, nowMs) {
  if (!isCmoeAllocationLedgerEnabled()) return { ok: true, released: 0 };
  const active = await allocationRepo.listActiveHolds(competitionId);
  let released = 0;
  for (const hold of active) {
    if (hold.matchId !== matchId) continue;
    await allocationRepo.saveHold(competitionId, releaseHold(hold, nowMs));
    released += 1;
  }
  await refreshActiveHoldsProjection(projectionRepo, allocationRepo, competitionId);
  return { ok: true, released };
}
